<style lang="scss">
@import './user-group-expression.scss';
</style>

<template>
  <!-- 没有匹配的任何筛选条件 -->
  <div v-if="userType.length === 0 && userAttribute.length === 0 && userBehavior.length === 0">
    {{ $t('userGroup.userExpression.nodata') }}
  </div>
  <Poptip v-else trigger="hover" placement="bottom-start">
    <!-- 显示当前筛选条件概述 -->
    <ul class="user-group-expression">
      <!-- 用户范围 -->
      <li v-if="userType.length" class="user-group-expression-item">
        <b>{{ $t('userGroup.userExpression.userType') }} :</b>
        <span v-for="item in userType" :key="item">{{$t(`userGroup.userExpression.${item}`)}}</span>
      </li>
      <!-- 用户属性 -->
      <li v-if="userAttribute.length" class="user-group-expression-item">
        <b>{{ $t('userGroup.userExpression.userAttribute') }} :</b>
        <span v-for="item in userAttribute" :key="item">{{$t(`userGroup.userExpression.userAttributeItem.${item}`)}}</span>
      </li>
      <!-- 用户行为 -->
      <li v-if="userBehavior.length" class="user-group-expression-item">
        <b>{{ $t('userGroup.userExpression.userBehavior') }} :</b>
        <span v-for="item in userBehavior" :key="item">{{$t(`userBehavior.${item}.title`)}}</span>
      </li>
    </ul>
    <!-- 显示当前筛选条件详情 -->
    <ul slot="content" class="user-group-expression-content" :style="{width: detailWidth + 'px'}">
      <!-- 用户范围 -->
      <li v-if="userType.length" class="user-group-expression-content-item">
        <span>{{ $t('userGroup.userExpression.userType') }} :</span>
        <span v-for="item in userType" :key="item">{{$t(`userGroup.userExpression.${item}`)}} {{data[item].join(' ~ ')}}</span>
      </li>
      <!-- 用户属性 -->
      <li v-if="userAttribute.length" class="user-group-expression-content-item">
        <p>{{ $t('userGroup.userExpression.userAttribute') }}</p>
        <p v-for="item in userAttribute" :key="item" class="user-group-expression-content-item-details">
          <detailsMove :itemName="item" :expression-info="data">
            <b slot="itemTitle">{{$t(`userGroup.userExpression.userAttributeItem.${item}`)}} :</b>
          </detailsMove>
        </p>
      </li>
      <!-- 用户行为 -->
      <li v-if="userBehavior.length" class="user-group-expression-content-item">
        <p>{{ $t('userGroup.userExpression.userBehavior') }}</p>
        <p v-for="item in userBehavior" :key="item" class="user-group-expression-content-item-details">
          <detailsMove :itemName="item" :expression-info="data">
            <b slot="itemTitle">{{$t(`userBehavior.${item}.title`)}} :</b>
          </detailsMove>
        </p>
      </li>
    </ul>
  </Poptip>
</template>
<script>
  import detailsMove from './user-group-expression-details';

  export default {
    name: 'expressionMove',
    props: {
      expressionInfo: String,
      detailWidth: Number,
    },
    data() {
      return {
        data: JSON.parse(this.expressionInfo) || {},
      };
    },
    components: {
      detailsMove,
    },
    computed: {
      userType() {
        const array = ['newuser', 'launchuser'];
        const objList = Object.keys(this.data);
        return objList.filter(x => array.indexOf(x) > -1);
      },
      userAttribute() {
        const array = ['user_region', 'isp_info', 'mobile_info', 'os_info', 'partner_info'];
        const objList = Object.keys(this.data);
        return array.filter(x => objList.indexOf(x) > -1);
      },
      userBehavior() {
        const array = ['launch_info', 'lostDays', 'customevent', 'page_view'];
        const objList = Object.keys(this.data);
        return array.filter(x => objList.indexOf(x) > -1);
      },
    },
  };
</script>
